import React, { lazy } from 'react'

const VideoPage = lazy(() => import('./VideoPage'))

export { VideoPage }
